import React from 'react';

const WhatsAppButton = () => (
  <a
    href="https://wa.me/5521978982711"
    className="wa"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Falar conosco pelo WhatsApp"
  >
    <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
      <path d="M20 4a10 10 0 0 0-15.7 12L3 21l5.2-1.3A10 10 0 1 0 20 4ZM12 19.3a7.4 7.4 0 0 1-3.9-1.1l-.3-.2-2.8.7.8-2.7-.2-.3A7.4 7.4 0 1 1 19.4 12 7.4 7.4 0 0 1 12 19.3Zm4-5.4-1.5-.7c-.2-.1-.4 0-.5.2l-.6.7a.3.3 0 0 1-.4.1 6 6 0 0 1-3-2.6c-.1-.2 0-.4.1-.5l.5-.6.1-.4-.7-1.7c-.2-.4-.5-.4-.7-.4h-.5a1 1 0 0 0-.7.3 2.9 2.9 0 0 0-.9 2.1c0 1.3.9 2.5 1 2.7 0 .1 1.8 2.8 4.4 3.9l1.5.5c.6.1 1.2.1 1.7 0 .5-.1 1.5-.7 1.7-1.3.2-.6.2-1.2.1-1.3l-.5-.3Z" />
    </svg>
  </a>
);

export default WhatsAppButton;
